/* Profile V10. This source is inserted in the existing React module by patch-profile.py. */
/* Inserted inside the existing React application; no auth data leaves memory. */

/* Decorative fallback for accounts without a photo. No initials or database writes. */

/* Display only: keep guide IDs, raw names, answer progress and saved metadata unchanged. */
function getGuideDisplayName(name) {
  const labels = {
    QF: "Questões fechadas",
    FH: "Flashcards",
    QA: "Questões abertas",
  };
  return (
    labels[
      String(name || "")
        .trim()
        .toUpperCase()
    ] || name
  );
}
function getGuideLearningKind(name) {
  const normalized = String(name || "")
    .trim()
    .toLocaleLowerCase("pt-BR");
  const kinds = {
    qf: "fechada",
    "questões fechadas": "fechada",
    fh: "flashcard",
    flashcards: "flashcard",
    qa: "aberta",
    "questões abertas": "aberta",
  };
  return kinds[normalized];
}
export { getGuideDisplayName, getGuideLearningKind };
